export default {
  FETCH_QANDA_EMAIL_TEMPLATES_REQUEST: 'FETCH_QANDA_EMAIL_TEMPLATES_REQUEST',
  FETCH_QANDA_EMAIL_TEMPLATES_SUCCESS: 'FETCH_QANDA_EMAIL_TEMPLATES_SUCCESS',
  FETCH_QANDA_EMAIL_TEMPLATES_FAILURE: 'FETCH_QANDA_EMAIL_TEMPLATES_FAILURE',
  UPDATE_QANDA_EMAIL_TEMPLATE: 'UPDATE_QANDA_EMAIL_TEMPLATE'
}
